import React, {Component} from 'react';

class ExposureTabsComponent extends Component {
    componentDidUpdate() {
        initTabs();
    }

    render() {
        return (
            <ul className="table-tab">
                <li className="active">
                    <a href="#players">Players</a>
                </li>
                <li>
                    <a href="#teams">Teams</a>
                </li>
                <li key={`stackSummary`}>
                    <a href="#stack-summary">Stacks</a>
                </li>
                <li key={`comboSummary`}>
                    <a href="#combo-summary">Combinations</a>
                </li>
            </ul>
        );
    }
}

const ExposureTabs = ExposureTabsComponent;

export {ExposureTabs};
